import React, { Component } from "react";
import { renderToString } from "react-dom/server";
import PropTypes from "prop-types";
import i18n from "i18n-react";

import {
  ActionCard,
  SharingPopup,
  AddFavorite,
  Image,
  WebsiteSplitter,
  LinkHandler,
} from "C4";
import { appContentUrl } from "settings";

const setIcon = (type) => {
  switch (type) {
    case "activeMap":
      return "fa-map-marker-alt";
    case "image":
      return "fa-images";
    case "web":
      return "fa-link";
    case "contact":
      return "fa-comments";
    case "layout":
      return "fa-clipboard";
    case "carousel":
      return "fa-th";
    case "multi":
      return "fa-external-link-alt";
    case "pdf":
      return "fa-file-pdf";
    case "directory":
      return "fa-list";
    default:
      return "";
  }
};

const parseURL = (url, type, appId) => {
  switch (type) {
    case "pdf":
      return `${appContentUrl}${appId}/${
        typeof url === "object" ? url[0] : url
      }`;
    case "image":
      return `${appContentUrl}${appId}/${
        typeof url === "object" ? url[0] : url
      }`;
    default:
      return url;
  }
};

const Slideshow = (props) => {
  const { appId, fancybox, options, urls } = props;

  const images = [];
  for (let i = 1; i < urls.length; i += 1) {
    const key = i;
    images.push(
      <div
        key={`ss_${key}`}
        href={
          urls[i].includes("http") ? urls[i] : parseURL(urls[i], "image", appId)
        }
        data-options={options}
        data-fancybox={fancybox}
        data-trigger={fancybox}
        data-type={urls[i].includes("http") && "iframe"}
        style={{ display: "none" }}
      >
        <Image
          src={parseURL(urls[i], "image", appId)}
          overrideZeroSize={100}
          alt="hidden"
        />
      </div>,
    );
  }

  return images;
};

export default class FastFactCard extends Component {
  render() {
    const { appId, image, index, subtitle, title, type, itemID } = this.props;
    let { url } = this.props;

    // Catches empty content by notifying user it's coming soon.
    if (url === "") {
      url = "#noContent";
    }

    if (url) {
      if (url.includes(",")) {
        url = url.split(",");
      }
    }

    let shareUrl = url;
    if (Array.isArray(shareUrl)) {
      shareUrl = window.location.href;
    }

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: "x",
      },
      baseClass: "customBox",
      buttons: ["thumbs", "share", "close"],
      share: {
        tpl: renderToString(
          <SharingPopup url={shareUrl} image={image} title={title} />,
        ),
      },
    };

    return (
      <div className="fastfacts__Card">
        <AddFavorite appId={appId} viewType="t" upID={itemID} />
        <LinkHandler
          appId={appId}
          url={url}
          type={type}
          title={title}
          UniqueID={itemID}
          dataOptions={JSON.stringify(fancyOptions)}
          dataFancybox={itemID}
          dataTrigger={itemID}
          className="fastfacts__Grid--item"
        >
          {/* Dummy image to fool fancybox thumbnails process */}
          {typeof url === "object" && (
            <Image
              src={`${appContentUrl}${appId}/${url[0]}`}
              alt="placeholder thumbnail"
              className="hidden"
            />
          )}
          <div
            id={`${title.toLowerCase().replace(" ", "_")}`}
            className="textContainer"
          >
            <ActionCard
              title={title}
              superTitle={subtitle}
              // buttonText={i18n.translate('fastFacts.view')}

              background
            />
          </div>
          <div className="imageContainer">
            {image && (
              <Image
                load={() => this.setState({ loading: false })}
                src={image}
                alt={image}
                gradient={false}
              />
            )}
            <div className="overlay" />
          </div>
          {typeof url === "object" && (
            <Slideshow
              appId={appId}
              fancybox={itemID}
              options={JSON.stringify(fancyOptions)}
              urls={url}
            />
          )}
        </LinkHandler>
        {type === "multi" && (
          <WebsiteSplitter itemID={itemID} appID={appId} type="FastFacts" />
        )}
        {/* Empty url notification */}
        {url === "#noContent" && (
          <div id="noContent" style={{ display: "none" }}>
            <h1>{i18n.translate("errors.comingSoon")}</h1>
            <p>{i18n.translate("errors.missingContent")}</p>
          </div>
        )}
      </div>
    );
  }
}

FastFactCard.propTypes = {
  appId: PropTypes.number.isRequired,
  image: PropTypes.string,
  index: PropTypes.number.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  itemID: PropTypes.string.isRequired,
};

FastFactCard.defaultProps = {
  image: "",
  subtitle: "",
  title: "",
  type: "",
};
